import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.43625 13.0026C2.16319 13.2231 2.0504 13.5115 2.00429 13.7238C1.4916 16.0853 2.23701 18.3679 3.88838 20.0763C5.47048 21.7129 7.87515 22.7354 10.3033 22.1192C12.8898 21.4629 15.4929 19.7239 17.6395 17.6625L17.6541 17.6484L17.6682 17.6338C19.7296 15.4872 21.4685 12.8842 22.1249 10.2976C22.741 7.8695 21.7186 5.46482 20.0819 3.88272C18.6378 2.48675 16.7924 1.70245 14.7676 1.84526C14.0164 1.89825 13.5989 2.42586 13.405 2.75817L17.3043 6.6575L15.8901 8.07171L11.3715 3.55312C10.6034 3.35876 9.85639 3.46554 9.24467 3.72548C8.73635 3.94148 8.29575 4.27185 8.00435 4.6438C7.86261 4.82472 7.71189 5.07203 7.64883 5.36914C7.58347 5.67705 7.60459 6.1299 7.9487 6.49426L12.7081 11.2537L11.2939 12.6679L6.53596 7.90996C6.16934 7.56233 5.71334 7.54402 5.40708 7.61001C5.11123 7.67376 4.86489 7.82443 4.68459 7.96597C4.31376 8.25708 3.98359 8.69694 3.76743 9.20491C3.50705 9.81681 3.39993 10.5641 3.59465 11.3326L8.11193 15.8499L6.69772 17.2641L2.43625 13.0026Z"}}]};

const BreadFilled = Vue.extend<IconProps>({
  name: 'BreadFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'bread-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default BreadFilled;
